import * as actionTypes from './../types/clientTypes'

const getUserLanguage = () => {

    let browserLanguage = (navigator.language || navigator.userLanguage)

    return (browserLanguage !== "en" && browserLanguage !== "fr")
        ? "fr"
        : browserLanguage
}

const INITIAL_STATE = {
    client: [],
    language: getUserLanguage(),
}

const clientReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case actionTypes.ADD_CLIENT:
            return {
                ...state,
                client: action.payload.client
            }

        case actionTypes.UPDATE_LANGUAGE:
            return {
                ...state,
                language: action.payload.language
            }

        default:
            return state
    }
}

export default clientReducer